import { removePartnerCustomerAccess } from '../forms/terminalCardGroup/form-tcg-helpers';
import useAuth from '../../hooks/auth-hooks';
import { ICardGroupTerminal } from '../../models/cardgroup.interface';

/**
 * Function that display a list of assoicated card groups for a given terminal
 * 
 * @param {object} data the card group data
 * @param {HTMLElement} container the container element for the widgets
 */
export const displayCardGroups = (data: Array<ICardGroupTerminal>, container: HTMLElement) => {
  if (!Array.isArray(data)) return;

  const { accessType } = useAuth()!;
  
  data.forEach((e: ICardGroupTerminal) => {
    const div = document.createElement('div');
    div.className = `single-row-widget aafp_border-radius linked-element ele_access_${e.cardGroupId}`;
    div.setAttribute(`data-id`, String(e.cardGroupId));
    div.setAttribute('data-name', e.cardGroupName);
    div.setAttribute('data-linked', String(e.cardGroupId));

    const span = document.createElement('span');
    span.textContent = e.cardGroupName;

    div.appendChild(span);
    if ( accessType != 'R') {
      const i = document.createElement('i');
      i.className = `far fa-trash-alt element-remove-${e.cardGroupId}`;
      i.setAttribute('data-toggle', 'tooltip');
      i.setAttribute('data-placement', 'bottom');
      i.setAttribute('title', `Remove ${e.cardGroupName}`);
      div.appendChild(i);
    }
    container.appendChild(div);

    removePartnerCustomerAccess(`.element-remove-${e.cardGroupId}`, e.cardGroupId);
  });
}